/**
 * Created with Mei Zhiwei on 2017-11-30 17:03:15.
 * Description: VUEX 常量
 *
 * @author meizhiwei@meituan.com
 * @version 1.0.0
 * @Last Modified by: meizhiwei@meituan.com
 * @Last Modified time: 2018-07-20 14:28:33
 */

export const CURRENT_USER = 'CURRENT_USER';
export const STATUSES = 'STATUSES';
export const BIZ_TYPES = 'BIZ_TYPES';
export const ACCESS_TYPES = 'ACCESS_TYPES';
export const APP_TYPES = 'APP_TYPES';
export const OP_BIZ_LIST = 'OP_BIZ_LIST';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js